module.exports = __webpack_public_path__ + "img/bonus_symbol_2.a887d1e5.png";